import React, {useState, useEffect} from 'react'
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import useAxiosPrivate from '../../context/hooks/useAxiosPrivate';
import { Spinner, Button, Row, Form, Modal } from 'react-bootstrap';
import PermissionWrapper from '../../context/PermissionWrapper';
import '../../appstyles/ClientsCSS/ClientsDetails.css'
import '../../appstyles/QuotesCSS/OrderDetails.css'

export const newsSchema = Yup.object().shape({
  news: Yup.string()
    .required('Este campo es requerido')
    .min(10, 'El campo debe tener al menos 10 caracteres')
});
  

function  TrackingOrderDetails() {
  // const { auth } = useAuth();
  const axiosInstance = useAxiosPrivate();
  const { trackId } = useParams();
  const [orderId, setOrderId] = useState(null);
  const [quote, setQuote] = useState(null);
  const [tracking, setTracking] = useState(null);
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { register, handleSubmit, reset, formState: { errors } } = useForm(
    {
      resolver: yupResolver(newsSchema),
    }
  )

  // Fetch tracking details 
  const fetchTrackingDetails = () => {
    axiosInstance.get(`api/logistics-tracking/${trackId}/`)
    .then(response => {
      const trackingDetails = response.data;
      setTracking(trackingDetails);
      reset({ news: trackingDetails.news })
      setOrderId(trackingDetails.quote_id);
    })
    .catch(error => {
      console.error('Failed to fetch tracking details', error);
    });
  };

  useEffect(() => {
    fetchTrackingDetails();
    // eslint-disable-next-line 
  }, [trackId, axiosInstance]);

  // Fetch order details
  useEffect(() => {
    if (!orderId) return; 
    axiosInstance.get(`api/quote/${orderId}/`)
      .then(response => {
        setQuote(response.data);
      })
      .catch(error => {
        console.error('Failed to fetch quote details', error);
      });
  }, [orderId, axiosInstance]);

  const handleSaveNews = (data) => {
    setLoading(true)
    axiosInstance.patch(`api/logistics-tracking/${trackId}/`, {
      news: data.news
      })
      .then(() => {
        fetchTrackingDetails();
        setEditing(false);
        setLoading(false)
      })
      .catch(error => {
        console.error('Failed to save supplier consecutive', error);
      });
  };

  const handleCancel = () => {
    setEditing(false);
  };

  const handleCancelTracking = () => {
    axiosInstance.patch(`api/logistics-tracking/${trackId}/`, {
      status: 'Cancelado'
    })
    .then(() => {
      fetchTrackingDetails();
      setShow(false);
    })
    .catch(error => {
      console.error('Failed to cancel tracking', error);
    });
  };

  if (!quote) {
    return(
    <div className='loading-container'>
      <p style={{fontFamily: 'Roboto, sans-serif'}}>Cargando...</p>
      <Spinner animation="border" variant="info" style={{width: '4.5rem', height: '4.5rem'}} />
    </div>
    );
  }

  return (
    <div className='maestros-details' style={{padding: '0px'}}>

      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
        <h4 style={{fontWeight: '700'}}>Detalles de Orden de Compra No. {quote.quote_id} </h4>

       {<PermissionWrapper feature='trazabilidad' action='delete'>
         <div style={{cursor: 'pointer'}} onClick={handleShow}>
           <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red" class="bi bi-trash" viewBox="0 0 16 16">
             <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
             <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
           </svg>
         </div>
       </PermissionWrapper>}
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-circle" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
              <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
            </svg>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>Estas a punto de cancelar la trazabilidad de la cotización No. {quote.quote_id} </h5>
          <p>¿Estás seguro de que la deseas cancelar? Esta acción no podrá ser revertida</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
          <Button variant="danger" onClick={handleCancelTracking}>
            Cancelar Trazabilidad
          </Button>
        </Modal.Footer>
      </Modal>

      
      <div style={{display: 'flex', flexDirection: 'row'}}>
      <div className='first-col'>
          <p><strong>Consecutivo:</strong> {quote.consecutive} </p>
          <p><strong>Cliente:</strong> {quote.client_name} </p>
          <p><strong>Proveedor:</strong> {quote.supplier_name} </p>
          <p><strong>Incoterm:</strong> {quote.incoterm} </p>
      </div>  

      <div className='second-col'>
          <p><strong>Consecutivo del cliente:</strong> {quote.client_consecutive} </p>
          <p><strong>Fecha de despacho solicitada:</strong> {quote.requested_delivery_date} </p>
          <p><strong>Ciudad de llegada:</strong> {quote.arrival_city} </p>
      </div>
      </div>

      <h4 style={{fontWeight: '700', color: '#07514F'}}>{quote.products.length > 1 ? 'Productos' : 'Producto'}</h4>
      {quote.products.map(product => (
      <Row key={product.id}>
      <div className='first-col' style={{margin: '0px'}}>
          <p><strong>Nombre del producto:</strong> {product.product_name} </p>
      </div>

      <div className='second-col' style={{padding: '0px'}}>
          <p><strong>Fabricante:</strong> {product.product_manufacturer}</p>
      </div>
      </Row>
      ))}

      <PermissionWrapper feature="trazabilidad" action="update">
        <hr />
        <div className='orders-details-actions'>
          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px', marginBottom: '0'}}>
            <h4 style={{fontWeight: '700', margin: 0}}>Novedades</h4>
            {!editing && (
              <button 
                className='btn btn-primary' 
                style={{backgroundColor: '#025C5A', borderColor: '#025C5A'}}
                onClick={() => setEditing(true)}
              >
                Editar
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16" style={{marginLeft: '10px'}}>
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                  <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                </svg>
              </button>
            )}
          </div>

          {editing ? (
            <Form onSubmit={handleSubmit(handleSaveNews)}>
              <Form.Group controlId="news">
                <Form.Control 
                  as="textarea" 
                  rows={5}  
                  placeholder="Novedades"
                  {...register('news')}
                  isInvalid={!!errors.news}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.news?.message}
                </Form.Control.Feedback>
              </Form.Group> 
              <Button
                variant="secondary"
                type="Submit"
                style={{
                  width: 'auto',
                  backgroundColor: '#056664',
                  border: ' solid 2px #025C5A',
                  margin: '0 2px'
                }}
              >
                {loading ? 'Cargando...' : 'Guardar'}
              </Button>
              <Button
                variant="secondary"
                onClick={handleCancel}
                style={{
                  width: 'auto',
                  backgroundColor: '#056664',
                  border: ' solid 2px #025C5A',
                  margin: '0 2px'
                }}
              >
                Cancelar
              </Button>
            </Form>    
          ) : null}
        </div>
        {/* Always show novedades content below novedades section */}
        {!editing && (
          <div style={{marginTop: '10px'}}>
            {tracking?.news ? (
              <p>
                {tracking.news.split('\n').map((line, idx) => (
                  <span key={idx}>
                    {line}
                    <br />
                  </span>
                ))}
              </p>
            ) : (
              <p style={{color: '#888'}}>No hay novedades para esta trazabilidad</p>
            )}
          </div>
        )}
      </PermissionWrapper>
    </div>
  )
}

export default TrackingOrderDetails 